<template>
	<div class="lightspot">
		<div class="content">
			<div class="title">优势亮点</div>
			<div class="lightspotContent flex-column">
				<div class="list flex-row">
					<div class="item " v-for="(item, index) in list.slice(0, 3)" :key="index">
						<div class="img flex-row flex-center"><img :src="item.IconUrl" alt=""></div>
						<div class="subTitle">{{item.title}}</div>
						<div class="content2 flex-row" v-for="(item, index) in item.textList" :key="item">
							<div class="dot"></div>
							<div class="text">{{ item }}</div>
						</div>
					</div>
				</div>
				<div class="list flex-row">
					<div class="item" v-for="(item, index) in list.slice(3, 6)" :key="index">
						<div class="img flex-row flex-center"><img :src="item.IconUrl" alt=""></div>
						<div class="subTitle">{{item.title}}</div>
						<div class="content2 flex-row" v-for="(item, index) in item.textList" :key="item">
							<div class="dot"></div>
							<div class="text">{{ item }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { WOW } from 'wowjs';
export default {
	mounted() {
		this.$nextTick(() => {
			// 在dom渲染完后,再执行动画
			var wow = new WOW({
				live: false,
				offset: 100
			});
			wow.init();
		});
	},
	methods: {
		change(index) {
			this.activeBar = index;
		}
	},

	data() {
		return {
			activeBar: 0,
			list: [
				{
					IconUrl:require('@/assets/home/icon/lightspotIcon1.png'),
					title: '方案整体化',
					textList: ['业务合规为本', '全业务链管理', '业财税一体化']
				},
				{
					IconUrl:require('@/assets/home/icon/lightspotIcon2.png'),
					title: '服务多样化',
					textList: ['全链服务转型', '服务项目众多', '支持个性定制']
				},
				{
					IconUrl:require('@/assets/home/icon/lightspotIcon3.png'),
					title: '业务三级化',
					textList: ['药企服务总控', '区域服务分包', '代表服务可及']
				},
				{
					IconUrl:require('@/assets/home/icon/lightspotIcon4.png'),
					title: '证据电子化',
					textList: ['真实业务记录', '自动汇总整合', '成果全链追溯']
				},
				{
					IconUrl:require('@/assets/home/icon/lightspotIcon5.png'),
					title: '税务全链化',
					textList: ['全链税务统筹', '个人服务经营', '上下税务穿透']
				},
				{
					IconUrl:require('@/assets/home/icon/lightspotIcon6.png'),
					title: '系统智能化',
					textList: ['电子签章', '智能合规审计', '行业数据支持']
				}
			]
		};
	}
};
</script>

<style lang="scss" scoped>
.title {
	margin: 0 auto;
	text-align: center;
	height: 45px;
	font-size: 32px;
	font-weight: 600;
	color: #333333;
	margin-bottom: 103px;
}
.lightspotContent {
	width: 100%;
	height: 580px;
	justify-content: space-between;
	.list{
		justify-content: space-between;
	}
	.item {
		transition: all 0.3s;
		.img{
			height: 46px;
			width: 46px;
			margin-top: 19px;
			margin-left: 73px;
		}
		width: 285px;
		height: 260px;
		background: linear-gradient(180deg, #F4F6F8 0%, #FEFEFF 100%);
		box-shadow: 0px 2px 4px 0px rgba(212,212,212,0.5);
		border-radius: 4px;
		border: 2px solid #FFFFFF;
		.subTitle{
			margin-top: 20px;
			margin-left: 75px;
			font-size: 24px;
			font-weight: 600;
			color: #333333;
			line-height: 33px;
			margin-bottom: 21px;
		}
		.content2{
			margin-left: 75px;
			align-items: center;
			margin-bottom: 10px;
			.dot {
				margin-right: 20px;
				width: 8px;
				height: 8px;
				border-radius: 4px;
				background: linear-gradient(90deg, #D0D0D0 0%, #E6E8EC 100%);
			}
			.text {
				font-size: 16px;
				font-weight: 400;
				color: #666666;
				line-height: 25px;
			}
		}
		
	}
	.item:hover {
		transform: scale(1.03);
	}
}
.lightspot {
	margin-top: 105px;
	height: 920px;
	background: $global-default-opacity-background
}
.lightspot::before {
	content: '';
	display: table;
}
.content {
	margin: 0 auto;
	margin-top: 82px;
	width: $global-content-width;
}
</style>
